import { useMemo } from 'react'
import { createMemo } from 'react-use'
import { reduce } from 'lodash-es'
import { useResultsStore } from '@editorStores'
import useElementCrossSectionAssignment from './useElementCrossSectionAssignment'

const guidToCrossSection = (elementCrossSectionAssignment: ElementCSAssignment[]) => {
  return reduce(
    elementCrossSectionAssignment,
    (col, assignment) => ({ ...col, [assignment.element_guid]: assignment.element_cs }),
    {} as Record<string, CrossSection>,
  )
}

const useMapGuidToCrossSection = createMemo(guidToCrossSection)

const useGuidToCrossSection = () => {
  const elementCrossSectionAssignment = useElementCrossSectionAssignment()

  const elementToCrossSection = useMapGuidToCrossSection(elementCrossSectionAssignment)

  const standardRipChecks = useResultsStore(state => state.standardRipChecks)
  const standardRipToCrossSection = useMemo(() => {
    return standardRipChecks?.reduce((collector, check) => {
      collector[check.standard_rip_member.guid] = check.standard_rip_member.cross_section
      return collector
    }, {} as Record<string, CrossSection>)
  }, [standardRipChecks])

  return useMemo(
    () => ({ ...elementToCrossSection, ...standardRipToCrossSection }),
    [elementToCrossSection, standardRipToCrossSection],
  )
}

export default useGuidToCrossSection
